import { cn } from '@/utils/cn'

export const selectClasses = cn(
  'w-full rounded-md border border-border-divider bg-surface-bg px-4 py-3 text-sm text-body font-light',
  'focus-visible:outline-none focus-visible:border-accent focus-visible:ring-2 focus-visible:ring-accent/30',
  'transition-colors duration-200',
)

export const textareaClasses = cn(
  'w-full rounded-md border border-border-divider bg-surface-bg px-4 py-3 text-sm text-body font-light',
  'placeholder:text-label/60 resize-none',
  'focus-visible:outline-none focus-visible:border-accent focus-visible:ring-2 focus-visible:ring-accent/30',
  'transition-colors duration-200',
)

export const labelClasses = 'text-xs uppercase tracking-widest text-label font-light'

export const submitButtonClasses = cn(
  'ml-auto px-6 py-2.5 rounded-full text-sm font-light tracking-wide min-h-11',
  'bg-btn-filled-bg text-btn-filled-text hover:bg-btn-filled-hover-bg',
  'transition-colors duration-200 disabled:opacity-50',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2',
)

export function capitalize(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export function fieldError(errors: Record<string, string[]>, field: string, label?: string): string | undefined {
  const messages = errors[field]
  return messages?.length
    ? `${label ?? capitalize(field.replace(/_/g, ' '))} ${messages[0]}`
    : undefined
}
